import { Appearance, DraftConfiguration, PrintType, Size } from '@/types';
import { assertNever } from '@/utils/assertNever';
import { printTypesForDesign } from '@/model/printType/printTypesForDesign';
import { printTypesForSpecialText } from '@/model/printType/printTypesForSpecialText';
import { printTypesForText } from '@/model/printType/printTypesForText';
import { getIsDieCutStickerAppearance } from '@/model/productType/getIsDieCutStickerAppearance';
import {
  isDraftConfigurationWithText,
  isDraftDesignConfiguration,
  isDraftSpecialTextConfiguration,
} from './isDraftConfigurationType';

const ZERO_SIZE: Size = { width: 0, height: 0, unit: 'mm' };

// returns available print types based on the current size of the configuration
export function getAvailablePrintTypes(
  configuration: DraftConfiguration,
  appearance: Appearance,
  ignoreTextSize?: boolean
): PrintType[] {
  const printArea = configuration.printArea;
  if (isDraftDesignConfiguration(configuration)) {
    return printTypesForDesign(
      configuration.design,
      printArea,
      appearance,
      configuration.rotation,
      configuration.scale
    );
  }

  // only allow design configurations on the die cut sticker
  if (getIsDieCutStickerAppearance(appearance)) {
    return [];
  }

  if (isDraftConfigurationWithText(configuration)) {
    return printTypesForText(
      printArea,
      appearance,
      configuration.text.style.font,
      ignoreTextSize ? ZERO_SIZE : configuration.size,
      configuration.text.style.fontSize * configuration.scale,
      configuration.rotation
    );
  }

  if (isDraftSpecialTextConfiguration(configuration)) {
    return printTypesForSpecialText(printArea, appearance);
  }

  return assertNever(configuration);
}
